import React from 'react';
import { useLocation } from 'react-router-dom';

const AppBreadcrumb = (props) => {
    const location = useLocation();
    
    let label = props?.meta?.label;

    if(location.pathname == '/hotList'){
        label= 'Hotlist';
    }

    return <>{location.pathname === '/' ? <span>Dashboard</span> : <span>{label==="Branch" || label==="Company" ? label+" "+"Dashboard" : label}</span>}</>;
};

export default AppBreadcrumb;
